import {Stack, Typography} from '@mui/material';
import {ExamModule} from '@cp/model';
import mapModuleTopicToTopicId from '../../../components/TopicSelection/map/mapModuleTopicToTopicId';
import {env} from '../../../config/env';
import {ListQuestionsSingleTopicVariables} from '../../../hooks/question/useListQuestions';
import mapModuleTopicToTopicString from '../../../utils/map/mapModuleTopicToTopicString';
import calculatePage from '../../../utils/calculate/calculatePage';

export interface AdminQuestionViewFiltersProps {
  filters: ListQuestionsSingleTopicVariables;
  selectedModule?: ExamModule;
}

export default function AdminQuestionViewFilters({filters, selectedModule}: AdminQuestionViewFiltersProps) {
  return (
    <Stack spacing={1}>
      {selectedModule && (
        <Typography variant="body2">
          <strong>Module:</strong> {selectedModule.name}
        </Typography>
      )}
      {filters.topic && filters.topic.trim() !== '' && selectedModule && (
        <Typography variant="body2">
          <strong>Topic:</strong>{' '}
          {(() => {
            const topic = selectedModule.topics.find((t) => mapModuleTopicToTopicId(t) === filters.topic);
            return topic ? mapModuleTopicToTopicString(topic, {spacer: ' • '}) : filters.topic;
          })()}
        </Typography>
      )}
      {filters.offset !== undefined && filters.limit !== undefined && (
        <Typography variant="body2">
          <strong>Pagination:</strong> Offset {filters.offset}, Limit {filters.limit} (Page{' '}
          {calculatePage(filters.offset, filters.limit)})
        </Typography>
      )}
      {filters.difficulty !== null && (
        <Typography variant="body2">
          <strong>Difficulty:</strong> {filters.difficulty} -{' '}
          {env.difficulty[filters.difficulty ?? 0]?.label || `Difficulty ${filters.difficulty ?? 0}`}
        </Typography>
      )}
      {filters.status && (
        <Typography variant="body2">
          <strong>Status:</strong> {env.question.status[filters.status]?.label || env.question.unknownStatus.label}
        </Typography>
      )}
    </Stack>
  );
}
